export default __webpack_public_path__ + "static/media/earn.4f3acf13.jpeg";